import checkMatch from './Functions/checkMatch';
import getParents from './Functions/getParents';

class State {
    constructor({ namespace, header, setActiveClassToCurrent }) {
        if (!namespace || !header) {
            return;
        }
        this.header = document.querySelector(header);

        this.listClass = `${namespace}__list`;
        this.itemClass = `${namespace}__item`;
        this.linkClass = `${namespace}__link`;

        this.activeState = '--active';
        this.currentState = '--current';

        this.setActiveClassToCurrent = setActiveClassToCurrent === undefined ? true : setActiveClassToCurrent;

        this.rootList = this.header.querySelector(`.${this.listClass}`);

        if (this.header && this.rootList) {
            let path = window.location.pathname;
            let currentLinks = this.selectLinksByHref(path);

            // If no links have been found, move up the path and try again
            while (currentLinks.length === 0 && path) {
                path = path
                    .split('/')
                    .slice(0, -1)
                    .join('/');
                currentLinks = this.selectLinksByHref(path);
            }

            currentLinks.forEach(currentLink => {
                this.setClasses(currentLink);
            });
        }
    }

    selectLinksByHref(path) {
        return this.rootList.querySelectorAll(`a[href^="/"][href$="${path}"]`);
    }

    setClasses(currentLink) {
        // Set classes to link
        if (this.setActiveClassToCurrent) {
            currentLink.classList.add(this.linkClass + this.activeState);
        }
        currentLink.classList.add(this.linkClass + this.currentState);

        // Set class to item
        let currentItem = currentLink.parentNode;
        if (checkMatch(currentItem, `.${this.itemClass}`)) {
            if (this.setActiveClassToCurrent) {
                currentItem.classList.add(this.itemClass + this.activeState);
            }
            currentItem.classList.add(this.itemClass + this.currentState);

            // Set active state also to parent items
            let parentItems = getParents(currentItem, `.${this.itemClass}`, this.header);
            parentItems.forEach(list => {
                list.classList.add(this.itemClass + this.activeState);
            });
        }

        // Set active state also to parent lists
        let parentLists = getParents(currentLink, `.${this.listClass}`, this.rootList, false);
        parentLists.forEach(list => {
            list.classList.add(this.listClass + this.activeState);
        });
    }
}

export default State;
